import script from "./SpendingTreemapPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpendingTreemapPage.vue?vue&type=script&setup=true&lang=ts"

import "./SpendingTreemapPage.vue?vue&type=style&index=0&id=db531414&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db531414"]])

export default __exports__